import { useMemo } from 'react'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { ExternalIntegration, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

export const useIntegrationHeartbeatStatus = () => {
  const { data: externalIntegrationsData } = useExternalIntegrations()
  const integrations = useMemo(() => externalIntegrationsData?.external_integrations || [], [externalIntegrationsData])

  const disconnectedIntegrations = useMemo(() => {
    if (!integrations) return []

    // Check is_active status - the source of truth for integration health
    // is_active is set immediately when heartbeat fails
    // disconnected_email_count is just an internal counter for email throttling
    return integrations.filter((integration: ExternalIntegration) => {
      return integration.is_active === false
    })
  }, [integrations])

  const hasDisconnectedIntegrations = disconnectedIntegrations.length > 0

  const outdatedScopeTikTokIntegration = useMemo(
    () =>
      integrations.find(
        (integration) =>
          integration.provider === ExternalIntegrationEnum.TikTok && !integration.scopes?.includes('video.list'),
      ),
    [integrations],
  )

  return {
    disconnectedIntegrations,
    hasDisconnectedIntegrations,
    disconnectedCount: disconnectedIntegrations.length,
    outdatedScopeTikTokIntegration,
    isIntegrationDisconnected: (integration: ExternalIntegration) => {
      return disconnectedIntegrations.some((disconnected) => disconnected.id === integration.id)
    },
  }
}
